import { Dialog, DialogTitle, FormControl, Select, MenuItem, Typography, Button, RadioGroup, FormControlLabel, Radio, TextField, DialogContent, DialogActions, Autocomplete } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from '../../../components/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import { AppContext } from '../../../AppContext';
import SFNoData from '../SFNoData';

const MAX_CODE_LENGTH = 15;

const SFCourseSectionEnrollDialog = ({
    open,
    handleCloseEnrollDialog,
    onMappingComplete,
    showCancelBtn
}) => {

    const appContext = useContext(AppContext);

    const [enrollType, setEnrollType] = useState("by-course");
    const [courseCode, setCourseCode] = useState("");

    const [allCourses, setAllCourses] = useState([]);
    const [selectedCourseEnroll, setSelectedCourseEnroll] = useState(null);
    const [selectedCourseEnrollName, setSelectedCourseEnrollName] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);

    const [courseSections, setCourseSections] = useState([]);
    const [selectedSectionEnroll, setSelectedSectionEnroll] = useState(null);
    const [selectedSectionEnrollName, setSelectedSectionEnrollName] = useState(null);

    const [loadingEnroll, setLoadingEnroll] = useState(false);

    const [courseLoading, setCourseLoading] = useState(false);
    const [sectionsLoading, setSectionsLoading] = useState(false);
    const [searchingCourseByCode, setSearchingCourseByCode] = useState(false);

    useEffect(() => {
        if (open) {
            getAllCourses()
        }
    }, [open])


    const resetState = () => {
        setCourseCode("");
        setSelectedCourseEnroll(null);
        setSelectedCourseEnrollName(null);
        setCourseSections([]);
        setSelectedSectionEnroll(null);
        setSelectedSectionEnrollName(null);
        getAllCourses();
    }

    const getAllCourses = () => {
        setCourseLoading(true);
        const responsePromise = ApiRequestService({
            method: 'post',
            url: '/getAllCoursesEnroll'
        })
        responsePromise.then(res => {
            if (res && res.data && res.data.data && res.data.data.course_names) {
                if (appContext?.isPublicSite) {
                    setAllCourses(res.data.data.course_names.filter(course => course.status === 1 && course.is_public === 1 && !course.is_special));
                } else {
                    setAllCourses(res.data.data.course_names.filter(course => course.status === 1 && !course.is_special));
                }
            }
        }).finally(() => {
            setCourseLoading(false);
        })
    }

    const getSections = (course_id) => {
        setSectionsLoading(true);
        const payload = {
            course_id: course_id
        }

        ApiRequestService({
            method: 'post',
            url: '/getAllSectionsEnroll',
            data: payload
        }).then(res => {
            var tempSectionArr = res.data.data.section_names;
            if (tempSectionArr != null) {
                let tempSelectedCourse = allCourses.find(cour => cour.course_id === course_id);
                if (appContext.isPublicSite && tempSelectedCourse && tempSelectedCourse.is_special) {
                    setSelectedSectionEnroll(tempSectionArr[0].section_id);
                    setSelectedSectionEnrollName(tempSectionArr[0].section_name);
                } else {
                    setSelectedSectionEnroll(null);
                    setSelectedSectionEnrollName(null);
                }
                setCourseSections(tempSectionArr);
            } else {
                setCourseSections([]);
            }
        }).finally(() => {
            setSectionsLoading(false);
        })
    }

    const getCourseFromCourseCode = () => {
        setSearchingCourseByCode(true);
        const payload = {
            code: courseCode
        }

        ApiRequestService({
            method: 'post',
            url: '/getCourseFromCourseCode',
            data: payload
        }).then(res => {
            console.debug("res.data>>??", res.data)
            if (res && res.data) {
                if (res.data.data) {
                    let course = res.data.data;
                    setSelectedCourseEnroll(course.course_id);
                    setSelectedCourseEnrollName(course.course_name);
                    getSections(course.course_id);
                } else if (res.data.message === "no course") {
                    NotificationManager.error("Course not found for this course code", "Not Found", 4000);
                }
            }
        }).finally(() => {
            setSearchingCourseByCode(false);
        })

    }

    const addMappingService = () => {
        setLoadingEnroll(true);
        let responsePromise = ApiRequestService({
            method: 'post',
            url: '/addStudentSectionEnrollment',
            data: {
                course_id: selectedCourseEnroll,
                section_id: selectedSectionEnroll
            }
        });
        responsePromise.then(res => {
            if (res.data.message !== null && res.data.message !== "") {
                if (res.data.message.toLowerCase().indexOf("duplicate") >= 0) {
                    NotificationManager.error("Duplicate entry. Section already Enrolled", "Error", 4000);
                } else if (res.data.message.indexOf("MaxSectionLimitReached") >= 0) {
                    NotificationManager.error("You cannot enroll in more than one section for every course", "Error", 4000);
                }
                else {
                    NotificationManager.error(res.data.message, "Error", 4000);
                }
            } else {
                NotificationManager.success("Successfully enrolled in the course", "Success", 4000);
                let courseName = selectedCourseEnrollName;
                let sectionName = selectedSectionEnrollName;
                onMappingComplete(courseName, sectionName);
            }
        }).finally(() => {
            setLoadingEnroll(false);
        })
    }

    let sectionContent = null;

    if (selectedCourseEnroll) {
        if (sectionsLoading) {
            sectionContent = (
                <center className="mt-3">
                    <BeatLoader loading={true} color='#bb0000' />
                    <Typography>Loading sections...</Typography>
                </center>
            );
        } else if (!courseSections || courseSections.length === 0) {
            sectionContent = (
                <div className="mt-3">
                    <SFNoData
                        title="No Sections found."
                        description="Please ask your instructor to create section for this course."
                    />
                </div>
            );
        } else {
            if (selectedCourse && selectedCourse.is_special && appContext.isPublicSite) {
                sectionContent = (
                    <center className='mt-4'>
                        <Typography fontSize={16}>
                            This is a special public course, permanently available for everyone.
                        </Typography>
                    </center>
                );
            } else {
                sectionContent = (
                    <FormControl fullWidth className="mt-3">
                        <label>Choose a Section:</label>
                        <Select
                            labelId="section-select"
                            id="section-select"
                            onChange={(event) => {
                                let sectionID = event.target.value;
                                setSelectedSectionEnroll(sectionID);
                                setSelectedSectionEnrollName(
                                    courseSections.find(s => s.section_id === sectionID)?.section_name
                                );
                            }}
                            displayEmpty
                            renderValue={(value) => {
                                if (!value)
                                    return <Typography color="gray">Select</Typography>;
                                return courseSections.find(s => s.section_id === value)?.section_name;
                            }}
                            value={selectedSectionEnroll || ""}
                        >
                            {courseSections.map(sec => (
                                <MenuItem key={sec.section_id} value={sec.section_id}>
                                    {sec.section_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }
        }
    }

    return (
        <Dialog open={open}
            maxWidth='sm'
            disablePortal
            fullWidth
            PaperProps={{
                sx: {
                    height: 400
                }
            }}
        >
            <DialogTitle>
                <Typography variant='h5' color='primary' fontWeight='500' className='mb-2'>Course-Section Enrollment</Typography>
                Enroll in a course to start seeing your assignments.
            </DialogTitle>
            <DialogContent >
                <RadioGroup
                    row
                    value={enrollType}
                    name="visibility"
                    onChange={(_, val) => {
                        setEnrollType(val);
                        setCourseCode("");
                        setSelectedCourseEnroll(null);
                        setSelectedCourseEnrollName(null);
                        setCourseSections([]);
                        setSelectedSectionEnroll(null);
                        setSelectedSectionEnrollName(null);
                        if (val === "by-course") {
                            getAllCourses();
                        }
                    }}
                >
                    <FormControlLabel disabled={courseLoading || sectionsLoading || searchingCourseByCode} value="by-course" control={<Radio />} label="By Course List" />
                    <FormControlLabel disabled={courseLoading || sectionsLoading || searchingCourseByCode} value="by-code" control={<Radio />} label="By Course Code" />
                </RadioGroup>

                {enrollType === "by-course" ?
                    (courseLoading ?
                        <center className="mt-3">
                            <BeatLoader loading={true} color='#bb0000' />
                            <Typography>Loading courses...</Typography>
                        </center>
                        :
                        <FormControl fullWidth>
                            <label>
                                Choose a Course:
                            </label>
                            <Autocomplete
                                options={allCourses?.filter(ac => !ac.is_lti_enabled) || []}
                                getOptionLabel={(option) => option.course_name}
                                value={allCourses.find(c => c.course_id === selectedCourseEnroll) || null}
                                onChange={(event, newValue) => {
                                    const courseID = newValue?.course_id || null;
                                    const courseName = newValue?.course_name || '';
                                    setSelectedCourseEnroll(courseID);
                                    setSelectedCourseEnrollName(courseName);
                                    setSelectedCourse(newValue);
                                    setSelectedSectionEnroll(null);
                                    if (courseID) getSections(courseID);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select"
                                        variant="outlined"
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.course_id === value.course_id}
                            />
                        </FormControl>
                    )
                    :
                    <React.Fragment>
                        <div className='d-flex justify-center items-center' style={{ gap: "4px" }}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    id='course-code'
                                    fullWidth
                                    size='small'
                                    placeholder='Please enter course code'
                                    inputProps={{ maxLength: MAX_CODE_LENGTH }}
                                    value={courseCode}
                                    onChange={e => setCourseCode(e.target.value)}
                                    disabled={selectedCourseEnroll !== null}
                                />
                                {/* <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    style={{ display: 'block', textAlign: 'left', marginTop: '4px' }}
                                >
                                    {courseCode.length}/{MAX_CODE_LENGTH}
                                </Typography> */}
                            </div>
                            <Button variant='contained' style={{ minWidth: '100px' }} onClick={() => {
                                getCourseFromCourseCode();
                            }}
                                disabled={selectedCourseEnroll !== null || searchingCourseByCode}
                            >
                                {searchingCourseByCode ? <BeatLoader size={10} loading={true} color='#bb0000' /> : "Search"}
                            </Button>
                        </div>

                        <div className='mt-2'>
                            Choosen course: <strong>{selectedCourseEnrollName}</strong>
                        </div>

                    </React.Fragment>
                }
                {sectionContent}
            </DialogContent>
            <DialogActions>
                {showCancelBtn ?
                    <Button variant='outlined'
                        onClick={handleCloseEnrollDialog}
                    >
                        Cancel
                    </Button>
                    : null}
                <Button variant='contained'
                    style={{ width: '105px' }} // this will give the consistent width even if the content changed to loading
                    disabled={selectedCourseEnroll === null || selectedSectionEnroll === null}
                    onClick={() => {
                        let payload = {
                            course_id: selectedCourseEnroll,
                            section_id: selectedSectionEnroll
                        }
                        addMappingService(payload)
                    }}>
                    {loadingEnroll ?
                        <BeatLoader
                            size={8}
                            color={"#fff"}
                        />
                        : "Enroll Now"
                    }
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SFCourseSectionEnrollDialog;
